export default __webpack_public_path__ + "static/media/investor-illustration-home.ae3973f1.png";